import { render, staticRenderFns } from "./ResultsCulture.vue?vue&type=template&id=7a8a6cd0&"
import script from "./ResultsCulture.vue?vue&type=script&lang=js&"
export * from "./ResultsCulture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports